export default {
  googleAnalyticsMeasurementId: 'G-YWTVXGQDNE',
  googleAnalyticsConsentManagement: false
}
